var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.modalId,
        "aria-label": _vm.modalTitle,
        "modal-class": "select-folder-modal",
        "ok-only": "",
        "ok-disabled": !_vm.selectedItems.length,
      },
      on: {
        show: _vm.applyInitialStockTab,
        ok: _vm.handleOkClick,
        hidden: _vm.resetModalState,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "modal-header",
            fn: function ({ close }) {
              return [
                _c(
                  "div",
                  { staticClass: "select-folder-modal__header" },
                  [
                    _c("h5", { staticClass: "select-folder-modal__title" }, [
                      _vm._v(
                        "\n        " + _vm._s(_vm.modalTitle) + "\n      "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-tabs",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.viewTabs,
                            expression: "viewTabs",
                          },
                        ],
                        staticClass: "c-file-browser select-folder-modal__tabs",
                        attrs: { pills: "" },
                      },
                      [
                        _c("b-tab", {
                          attrs: {
                            title: "Files",
                            active: _vm.currentTab === _vm.TABS.FILES,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.navigate(_vm.TABS.FILES)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("b-tab", {
                          attrs: {
                            title: "Products",
                            active: _vm.currentTab === _vm.TABS.PRODUCTS,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.navigate(_vm.TABS.PRODUCTS)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("b-tab", {
                          attrs: {
                            title: "Stock",
                            active: _vm.currentTab === _vm.TABS.STOCK,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.navigate(_vm.TABS.STOCK)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm.isSalsifyAvailable
                          ? _c("b-tab", {
                              attrs: {
                                title: "Salsify Products",
                                active:
                                  _vm.currentTab === _vm.TABS.SALSIFY_PRODUCTS,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.navigate(_vm.TABS.SALSIFY_PRODUCTS)
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isSalsifyAvailable
                          ? _c("b-tab", {
                              attrs: {
                                title: "Salsify Assets",
                                active:
                                  _vm.currentTab === _vm.TABS.SALSIFY_ASSETS,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.navigate(_vm.TABS.SALSIFY_ASSETS)
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isBoxAvailable
                          ? _c("b-tab", {
                              attrs: {
                                title: "Box Assets",
                                active: _vm.currentTab === _vm.TABS.BOX_ASSETS,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.navigate(_vm.TABS.BOX_ASSETS)
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("b-tab", {
                          attrs: {
                            title: "Briefs",
                            active: _vm.currentTab === _vm.TABS.BRIEF,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.navigate(_vm.TABS.BRIEF)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm.showLayouts
                          ? _c("b-tab", {
                              attrs: {
                                title: "Layouts",
                                active: _vm.currentTab === _vm.TABS.LAYOUTS,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.navigate(_vm.TABS.LAYOUTS)
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close select-folder-modal__close",
                        attrs: { type: "button", "aria-label": "Close" },
                        on: {
                          click: function ($event) {
                            return close()
                          },
                        },
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          _vm.showCreateLayers
            ? {
                key: "modal-footer",
                fn: function ({ cancel }) {
                  return [
                    _c(
                      "b-form-checkbox",
                      {
                        staticClass: "mr-auto",
                        attrs: { switch: "" },
                        model: {
                          value: _vm.createLayers,
                          callback: function ($$v) {
                            _vm.createLayers = $$v
                          },
                          expression: "createLayers",
                        },
                      },
                      [_vm._v("\n      Create Layers\n    ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "outline-secondary" },
                        on: {
                          click: function ($event) {
                            return cancel()
                          },
                        },
                      },
                      [_vm._v("\n      Cancel\n    ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        attrs: {
                          variant: "primary",
                          disabled:
                            !_vm.selectedItems.length ||
                            (_vm.createLayers &&
                              _vm.selectedItems.length !== 1),
                        },
                        on: { click: _vm.handleOkClick },
                      },
                      [_vm._v("\n      OK\n    ")]
                    ),
                  ]
                },
              }
            : null,
        ],
        null,
        true
      ),
    },
    [
      _vm._v(" "),
      _vm.isFolderTab
        ? _c("SelectFolderModalContentView", {
            attrs: {
              "allow-multiple-selection": _vm.mode !== "selectAndCreate",
              "is-light-weight": _vm.isLightWeight,
            },
            on: { onSelectedItems: (items) => (_vm.selectedItems = items) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isStockTab
        ? _c("ExternalContentView", {
            attrs: { endpoint: _vm.stockEndpoint },
            on: { onSelectedItems: (items) => (_vm.selectedItems = items) },
            scopedSlots: _vm._u(
              [
                {
                  key: "toolbar-start",
                  fn: function () {
                    return [
                      _c(
                        "b-tabs",
                        {
                          staticClass: "c-file-browser c-file-browser--stock",
                          attrs: { pills: "" },
                        },
                        [
                          _c("b-tab", {
                            attrs: {
                              title: "It'sRapid",
                              active:
                                _vm.currentStockTab ===
                                _vm.TABS.ITS_RAPID_STOCK,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.navigateStock(
                                  _vm.TABS.ITS_RAPID_STOCK
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("b-tab", {
                            attrs: {
                              title: "Pixabay",
                              active:
                                _vm.currentStockTab === _vm.TABS.PIXABAY_STOCK,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.navigateStock(_vm.TABS.PIXABAY_STOCK)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1641674403
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isSalsifyTab
        ? [
            _c("ExternalContentView", {
              attrs: { endpoint: _vm.salsifyEndpoint },
              on: {
                onSelectedItems: (items) => (_vm.selectedItems = items),
                autoConfirm: _vm.handleOkClick,
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isBoxTab
        ? _c("ExternalContentView", {
            attrs: { endpoint: _vm.boxEndpoint, "navigable-folders": "" },
            on: { onSelectedItems: (items) => (_vm.selectedItems = items) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isBriefTab
        ? _c("BriefsTabContentView", {
            attrs: { "default-brief-id": _vm.defaultBriefId },
            on: { onSelectedItems: (items) => (_vm.selectedItems = items) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isLayoutsTab
        ? _c("LayoutsContentView", {
            on: { onLayoutLayers: _vm.handleLayoutLayers },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }